<template>
  <div class="vip-box">
    <div class="vip">
    <div class="vip_box" v-if="list.length">
      <div v-loading="vipListLoad" v-if="vipList.length">
        <div v-for="(vip, index) in vipList" :key="index">
          <div class="vip_box_list" v-if="vipType == vip.id">
            <div v-for="(item, ind) in list" :key="item.id" :class="['vip_box_item', {'active': vipActive == ind}]" @click="changeVip(ind)">
              <img class="card" :src="`${backURL}/apis/upload${item.logoId}`" />
              <div class="right">
                <h3>{{ item.name }}</h3>
                <div class="yuanjia">
                  定价 ：￥{{ item.scribingPrice ? item.scribingPrice : pr }}
                </div>
                <!-- <div class="xianjia">
                  优惠价 ：<span style="color: #ff0000; font-size: 20px">￥{{ item.markingPrice }}</span>
                </div> -->
                <div class="xianjia" v-if="item.endDate != null && item.endDate">
                  使用有效期至：
                  <span>{{ new Date(item.endDate).format('yyyy-MM-dd') }}</span>
                </div>
                <div class="xianjia" v-else>
                  购买后 {{ Math.floor(item.indate / 1000 / 60 / 60 / 24) }} 天有效
                </div>
                <div class="price"><button @click.stop="buyProcurement(item.id)">立即购买</button></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="vip_no">
      <p>请在后台创建会员卡</p>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      custom-class="pay-dialod-visible"
      @close="closeDialog"
      >
      <div class="count">
        <div v-if="!wxPay" class="zfb_box">
          <!-- 新用户  -->
          <div>
            <!-- <ul> -->
              <!-- <li>
                <el-button class="fillIn" type="text" @click="receiptVisible = true">填写</el-button>
                <span class="label">发票信息</span>
                <span v-if="!receiptSuccess">请填写发票信息</span>
                <span v-else>电子普通发票 {{receiptType == 1 ? '个人' : '单位'}}</span>
              </li> -->
              <!-- <li>
                <el-button class="fillIn" type="text" @click="addressVisible = true">填写</el-button>
                <span class="label">收货地址</span>
                <span v-if="!addressSuccess">请填写收货地址</span>
                <span v-else>{{ addressInfo.address }}</span>
              </li> -->
              <!-- <li><span class="label">团购码</span> <el-input style="width: 160px" v-model="freeGift" placeholder="请输入团购码" @blur="setFreeGift"></el-input></li> -->
            <!-- </ul> -->
            <p class="tip">微信、支付宝均可支付，请选择</p>
            <div class="right_f">
              <div class="wx" @mouseenter="wxEnter" @mouseleave="wxLeave" @click="weChatPayment">
                <img class="pay_logo" src="../../assets/images/main/wx1.png">
                <span class="pay_type">微信支付</span>
                <span class="pay_num">￥{{orderInfo.orderAmount}}</span>
              </div>
              <div class="zfb" @click="alipayPayment">
                <img class="pay_logo" src="../../assets/images/main/zfb1.png" alt="">
                <span class="pay_type">支付宝支付</span>
                <span class="pay_num">￥{{orderInfo.orderAmount}}</span>
              </div>

              <div class="balance" v-if="model == 'client'">
                <div class="left">
                  <img src="@/assets/images/client/qianbao.png" alt="">
                  <div class="msg">
                    <span>余额</span> <span style="color: #ff0000">{{price}}</span>
                    <span style="font-size: 14px; color: #ff0000" v-if="balanceShow">（不足支付）</span>
                  </div>
                </div>
                <button class="right" v-if="balanceShow" @click="openWindows">充值</button>
                <button class="right" v-else @click="balancePayment">支付</button>
              </div>
            </div>
             <ul>
              <li style="line-height: 2">
                <span><strong><b>汇款购买</b></strong></span>
                <div style="margin-left:15px">
                  <p>
                    有特殊需求的顾客请直接汇款到以下账户，并致电400-1183-985说明情况
                  </p>
                  <p>户名：北京尚壹本科技有限公司</p>
                  <p>账号：110061506013000744084</p>
                  <p>开户银行：交行北京天竺支行</p>
                  <p>(汇款备注请注明所购产品)</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div v-else class="wx_box">
          <h3>微信扫描二维码完成支付</h3>
          <div class="wx_box-price"><span style="color: #e50001; font-size: 28px;">￥</span> <span class="p_num_new" style="font-size: 28px; color: #e50001;">{{orderInfo.orderAmount ? orderInfo.orderAmount : 200}}</span></div>
          <div class="right">
            <div class="right_QrCode">
              <qrCode class="right_QrCode_img" v-if="payCodeUrl" :pay-code-url="payCodeUrl"></qrCode>
            </div>
          </div>
          <p class="pOne">打开微信【扫一扫】扫描上方的二维码，按操作提示完成支付</p>
          <p class="pOne">请在2小时内完成操作，超时后需要重新开始购买</p>
        </div>
      </div>
      <!-- 内层的dialog -->
      <el-dialog
        width="30%"
        title="填写收货地址"
        :visible.sync="addressVisible"
        append-to-body>
        <el-form ref="addressInfo" :model="addressInfo" :rules="addressRules" label-width="80px">
          <el-form-item label="收件人" prop="name">
            <el-input v-model="addressInfo.name" placeholder="请输入收件人名称"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="addressInfo.phone" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item label="收件地址" prop="address">
            <el-input v-model="addressInfo.address" placeholder="请输入收件地址"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitAddress('addressInfo')">保存</el-button>
            <el-button @click="addressVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-dialog
        width="30%"
        title="填写发票信息"
        :visible.sync="receiptVisible"
        append-to-body>
        <el-form ref="receiptForm" :model="receiptInfo" :rules="receiptRules" label-width="110px">
          <el-form-item label="发票类型">
            <span>电子普通发票</span>
          </el-form-item>
          <el-form-item label="抬头类型">
            <el-radio-group v-model="receiptType" @change="receiptSelect">
              <el-radio :label="1">个人</el-radio>
              <el-radio :label="2">单位</el-radio>
            </el-radio-group>
          </el-form-item>
          <div v-if="receiptType == 2">
            <el-form-item label="发票抬头" prop="title" :rules="[{ required: true, message: '请输入发票抬头', trigger: 'blur'}]">
              <el-input v-model="receiptInfo.title" placeholder="请输入发票抬头"></el-input>
            </el-form-item>
            <el-form-item label="纳税人识别号" prop="identificationNum" :rules="[{ required: true, message: '请输入纳税人识别号', trigger: 'blur' }]">
              <el-input v-model="receiptInfo.identificationNum" placeholder="请输入纳税人识别号"></el-input>
            </el-form-item>
          </div>
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="receiptInfo.phone" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="receiptInfo.email" placeholder="请输入邮箱"></el-input>
          </el-form-item>
          <el-form-item label="发票内容">
            <span>尚壹本会员服务</span>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitReceipt('receiptForm')">保存</el-button>
            <el-button @click="receiptVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-dialog>
    <div v-html="html"></div>
    <el-image-viewer
      v-if="dialogImageViewer && freeGiftPic.length"
      :on-close="() => { dialogImageViewer = false }"
      :url-list="freeGiftPic">
     </el-image-viewer>
  </div>
  </div>
</template>

<script>
import qrCode from "@/components/qr-code/qr-code-for-wxpay"
  export default {
    data () {
      //手机号
      let phone_valid = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
      var phone_is_nan = (rule, value, callback) => {
        if(!value.match(phone_valid)){
          callback(new Error("不是一个手机号!"));
        } else {
          callback()
        }
      }
      return {
        model: '',
        backURL: this.$config.backURL,
        isValid: false,
        addressVisible: false,
        addressInfo: {
          name: '',
          address: '',
          phone: ''
        },
        addressRules: {
          phone: [
            { required: true, message: "请输入手机号码", trigger: "blur" },
            { min: 11, max: 11, message: "手机号码长度11", trigger: "blur" },
            { validator: phone_is_nan, trigger: "blur" },
          ],
          name: [
            { required: true, message: "请输入收件人姓名", trigger: "blur" }
          ],
          address: [
            { required: true, message: "请输入收件地址", trigger: "blur" },
          ],
        },
        receiptRules: {
          phone: [
            { required: true, message: "请输入手机号码", trigger: "blur" },
            { min: 11, max: 11, message: "手机号码长度11", trigger: "blur" },
            { validator: phone_is_nan, trigger: "blur" },
          ],
          email: [
            { required: true, message: "请输入邮箱", trigger: "blur" }
          ]
        },
        freeGift: '',
        vipList: [],
        dialogImageViewer: false,
        receiptVisible: false,
        receiptType: 1, // 个人 单位
        receiptSuccess: false, // 发票填写验证是否通过
        addressSuccess: false, // 地址验证是否通过
        receiptInfo: {
          userId: null,
          phone: '',
          email: '',
          content: '',
          title: '',
          identificationNum: ''
        },
        vipActive: 0,
        vipType: 1,
        dialogVisible: false,
        wxPay: false,
        orderInfo: {},
        payCodeUrl: '',
        uid: 0,
        html: '',
        valueIndex: 0,
        list: [],
        subjectArr: [
          {
            subjectId: 9,
            name: '语文'
          },
          {
            subjectId: 10,
            name: '数学'
          },
          {
            subjectId: 11,
            name: '英语'
          },
          {
            subjectId: 12,
            name: '物理'
          },
          {
            subjectId: 13,
            name: '化学'
          },
          {
            subjectId: 14,
            name: '生物'
          },
          {
            subjectId: 15,
            name: '历史'
          },
          {
            subjectId: 16,
            name: '地理'
          },
          {
            subjectId: 17,
            name: '政治'
          }
        ],
        vipListLoad: false,
        freeGiftPic: [],

        price: 0 // 账号余额
      }
    },
    components: {
      qrCode,
      'el-image-viewer':()=>import('element-ui/packages/image/src/image-viewer')
    },
    computed: {
      balanceShow() {
        let pic = this.orderInfo.orderAmount ? this.orderInfo.orderAmount : 200
        if (pic > this.price) {
          return true // 显示充值
        } else {
          return false
        }
      },
      pr () {
        if (this.vipType == 1) {
          return 8000
        } else if (this.vipType == 2) {
          return 16000
        } else if (this.vipType == 3) {
          return 24000
        } else {
          return 32000
        }
      }
    },
    methods: {
      // 获取余额信息
      getBalance() {
        this.$HTTP.executeGet(`${this.$APIS.GET_USER_BLANCE}/${this.uid}`, this).then((res) => {
          const { data, code, msg } = res
          if (code === 0) {
            this.price = data
          } else {
            this.$message.error(msg);
          }
        })
      },
      openWindows () {
        try {
          cefJS.sendmsg('balance');
          this.dialogVisible = false
        } catch (error) {
          console.log(error)
        }
      },
      balancePayment () {
        this.$HTTP.executeGet(`${this.$APIS.PAY_BALANCE}/${this.orderInfo.id}`, this).then((res) => {
          const { data, code, msg } = res
          if (code == 0) {
            this.$message.success(msg)
            this.$router.push({
              path: '/tfedu_common/home'
            })
          }
        })
      },
      // 推广码接口
      setFreeGift() {
        if (!this.freeGift) {
          this.$message.error('请输入团购码！')
          return false
        }
        this.isValid = false
        this.$axios.get(`agent/find-by-code/${this.freeGift}`).then(res => {
          const { data, status } = res
          if (status == 200) {
            
            if (data.code == 1) {
              this.isValid = false
              this.$message.error('团购码不正确，请联系你的团长。')
            } else if(data.code == 0) {
              let params = {
                code: this.freeGift,
                orderNo: this.orderInfo.orderNo
              }
              this.$HTTP
                .executePost(this.$APIS.SET_MODIFY_BY_ORDERNUMBER, params ,this)
                .then((res) => {
                  if (res.code != 0) {
                    this.$message.error('团购码不正确，请联系你的团长。')
                  } else {
                    this.isValid = true
                    this.$message.success('团购码有效')
                  }
                });
            } else {
              this.$message.error('团购码异常。')
            }
          } else {
            this.$message.error('请求失败')
          }
        })
      },
      receiptSelect (val) {
        if(val == 2) {
          this.receiptInfo.content = "尚壹本会员服务"
        } else if(val == 1) {
          this.receiptInfo.identificationNum = ""
          this.receiptInfo.title = ""
          this.receiptInfo.content = ""
        }
      },
      phone_is_nan(rule, value, callback) {
        let phone_valid = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
        if(!value.match(phone_valid)){
          callback(new Error("不是一个手机号!"));
        } else {
          callback()
        }
      },
      // 保存地址
      submitAddress(val) {
        this.$refs[val].validate((valid) => {
          if (valid) {
            let params = {
              userId: this.uid,
              name: this.addressInfo.name,
              phone: this.addressInfo.phone,
              address: this.addressInfo.address,
              orderNumber : this.orderInfo.orderNo
            }
            this.$HTTP
              .executePost(this.$APIS.SET_GOODS_ADDRESS, params ,this)
              .then((res) => {
                if (res.code === 0) {
                  this.$message.success('地址保存成功')
                  this.addressSuccess = true // 地址验证通过
                  this.addressVisible = false
                } else {
                  this.$message.error('地址保存失败')
                }
              });
          }
        })
      },
      // 保存发票信息
      submitReceipt(val) {
        this.$refs[val].validate((valid) => {
          if (valid) {
            let params = {
              billing: {
                userId: this.uid,
                phone:　this.receiptInfo.phone,
                email: this.receiptInfo.email,
                content: this.receiptInfo.content,
                title: this.receiptInfo.title,
                identificationNum: this.receiptInfo.identificationNum
              },
              orderNumber: this.orderInfo.orderNo
            }
            this.$HTTP
              .executePost(this.$APIS.SET_BILLING_ADD, params ,this)
              .then((res) => {
                if (res.code === 0) {
                  this.$message.success('发票保存成功')
                  this.receiptSuccess = true // 发票验证通过
                  this.receiptVisible = false
                } else {
                  this.$message.error('发票失败成功')
                }
              })
          }
        })
      },
      getVipList(id) {
        this.vipListLoad = true
        let params = {
          categoryId: 2,
          typeId: id
        }
        this.$axios.post(`goods/get-vip-package-trade`, params).then(res => {
          const { status, data } = res
          if (status === 200) {
            if (data.code === 0) {
              this.list = []
              this.vipListLoad = false
              const pdata = data.data
              this.list = pdata
            } else {
              this.vipListLoad = false
            }
          }
        }).catch(err => {
          this.$message.error(err)
        })
      },
      showGiftImage() {
        // this.dialogImageViewer = true
        // const newRouter = this.$router.resolve({path: '/gift', query: {type: this.vipType}})
        window.open(this.$config.backURL,'_blank')
      },
      changeVip(index) {
        this.vipActive = index
        if (this.list[index].freeGift != null && this.list[index].freeGift.length) {
          this.freeGiftPic = this.list[index].freeGift.split(',')
        } else {
          this.freeGiftPic = []
        }
      },
      selectVip(val) {
        this.vipType = val
        this.vipActive = 0
        if (this.list[0].freeGift != null && this.list[0].freeGift.length) {
          this.freeGiftPic = this.list[0].freeGift.split(',')
        } else {
          this.freeGiftPic = []
        }
        this.getVipList(val)
      },
      // 关闭弹层 重置参数
      closeDialog() {
        this.wxPay = false
      },
      wxEnter() {
        this.wxShow = true
      },
      wxLeave() {
        this.wxShow = false
      },
      weChatPayment() {
      //查询是否有订单
      // if (!this.isValid) {
      //   this.$message.error('请输入团购码!')
      //   return false
      // }
      //在这里请求接口,通过订单获得生成的二维码
        let params = {
          orderNumber: this.orderInfo.orderNo,
          userId: this.uid
        }
        this.$axios.post('wxpay/create-vip-pre-order', params).then(res => {
          const { data, status } = res
          if (status === 200) {
            if (data.code === 0) {
              this.payCodeUrl = data.data.code_url;
              this.wxPay = true;
              this.quertOrderStatus();
            } else {
              this.$message.error("获得支付二维码失败,请重试!")
            }
          }
        })
        //  = 'weixin://wxpay/bizpayurl?pr=Khjd4GM00';
        //轮训请求订单的支付状态
      },
      quertOrderStatus(){
      // 查看订单状态
        this.$axios.get(`vip/order/find/${this.orderInfo.id}`).then(res => {
          const { status, data } = res
          if (status === 200) {
            if (data.code === 0) {
              if (data.data.status != null && data.data.status == '1') {
                this.$router.push({
                  path: '/tfedu_common/home'
                })
              } else {
                setTimeout(() => {
                  this.quertOrderStatus();
                }, 2000);
              }
            }
          }
        })
      },
      alipayPayment() { // 支付宝支付
        //查询是否有订单
        // if (!this.isValid) {
        //   this.$message.error('请输入团购码!')
        //   return false
        // }
        let param = {
          orderNumber: this.orderInfo.orderNo,
          userId: this.uid
        }
        // 请求支付宝支付接口
        this.$axios.post('alipay/vip/pay', param).then(res => {
          const { data } = res
          if (data.code === 0) {
            if (data.data.length) {
              this.html = data.data;
              this.$nextTick(() => {
                document.forms[0].submit()
              })
            } else {
              this.$message.error(data.msg)
            }
          }
        })
      },
      buyProcurement(GoodsId) {
        // 获取一下余额信息
        this.getBalance()
        // 是否登陆的判断
        if(!window.localStorage.getItem("isLogin")) {
          this.$store.commit("changeIsShowLogin", true);
          return false
        }

        let params = {
          userId: this.uid,
          tradeGoodsId: GoodsId,
        }

        // 创建订单
        this.$axios.post('vip/order/add', params).then((resD) => {
          const { status, data } = resD
          if (status === 200) {
            if (data.code === 0) {
              this.orderInfo = data.data
              this.dialogVisible = true
            }
          }
        })
        //查询是否有订单
        // this.$axios.get(`vip/order/find/order-exist/${this.uid}/${vipId}`).then((res) => {
        //   const { status, data } = res
        //   if (status === 200) {
        //     if (data.code) {
        //       // 创建订单
        //       this.$axios.post('vip/order/add', params).then((resD) => {
        //         const { status, data } = resD
        //         if (status === 200) {
        //           if (data.code === 0) {
        //             this.orderInfo = data.data
        //             this.dialogVisible = true
        //           }
        //         }
        //       })
        //     } else {
        //       // 使用这个订单号进行支付
        //       this.orderInfo = data.data
        //       this.dialogVisible = true
        //     }
        //   }
        // })
      },
      changeIndex(value) {
        this.valueIndex = +value
      },
      subjectFilter(str) {
        let arr = str.split(',')
        if (arr.length === 9) {
          return '全'
        } else {
          let strSub = []
          for (let i = 0; i < arr.length; i++) {
            const element = arr[i]
            for (let j = 0; j < this.subjectArr.length; j++) {
              const subjectArrElement = this.subjectArr[j]
              if(+element === subjectArrElement.subjectId) {
                strSub.push(subjectArrElement.name)
              }
            }
          }
          return strSub.join('、')
        }
      }
    },
    created() {
      this.model = localStorage.getItem('model') || this.$route.query.model || ''
      this.vipType = +this.$route.query.type
      let user_json = localStorage.getItem('userinfo')
      if (user_json != null && user_json.length) {
        let userInfo = JSON.parse(user_json)
        this.uid = userInfo.id
      }
      this.getBalance()
      // 获取会员卡种类列表
      this.$HTTP
        .executeGet(this.$APIS.GET_VIP_TYPE, this)
        .then((response) => {
          if (response.code == 0) {
            this.vipList = response.data
          }
        });
      if (this.vipType === 5) {
        this.vipListLoad = true
        let params = {
          categoryId: 3
        }
        this.$axios.post(`goods/get-vip-package-trade`, params).then(res => {
          const { status, data } = res
          if (status === 200) {
            if (data.code === 0) {
              this.list = []
              this.vipListLoad = false
              const pdata = data.data
              this.list = pdata
            } else {
              this.vipListLoad = false
            }
          }
        }).catch(err => {
          this.$message.error(err)
        })
      } else {
        this.getVipList(this.vipType)
      }
    },
    // watch: {
    //   dialogVisible(newName, oldName) {
    //     if (!newName) {
    //       this.groupShow = true
    //     }
    //   }
    // }
  }
</script>

<style lang="scss" scoped>
/deep/ .el-image-viewer__canvas img {
  background-color: #fff !important;
}
.vip-box {
  width: 100%;
  min-height: 100%;
  height: auto;
  background: #fff;
}
  .vip {
    margin: 0 auto;
    width: 1520px;
    height: auto;
    background-color: #fff;
    .banner {
      width: 100%;
      height: auto;
    }
    .vip_tab {
      width: 510px;
      height: 75px;
      border-bottom: 2px solid #efefef;
      margin: 0 auto;
      padding-top: 30px;
      margin-bottom: 30px;

      .item {
        font-size: 20px;
        color: #a8a8a8;
        height: 43px;
        line-height: 43px;
        display: inline-block;
        width: 168px;
        text-align: center;
        cursor: pointer;
      }

      .active {
        border-bottom: 2px solid #af5aef;
        color: #7600ce;
      }
    }

    .vip_box {
      width: 1246px;
      height: auto;
      margin: 0 auto;
      .vip_box_list {
        width: 100%;
        height: auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }

      .vip_box_item {
        height: 187px;
        width: 590px;
        margin-top: 70px;
        border-radius: 9px;
        cursor: pointer;
        overflow: hidden;
        img {
          width: 294px;
          height: 187px;
        }
      }

      .vip_box_item:hover {
        box-shadow: 5px 5px 6px #ccd;
      }
      .active {
        box-shadow: 5px 5px 6px #ccd;
      }

      .explain {
        width: 968px;
        height: auto;
        color: #585858;
        font-size: 16px;
        padding: 50px;
        margin: 110px auto;
        border: 1px solid #aaaaaa;

        .gift_image {
          cursor: pointer;
          color: #2440B3;
        }
        .gift_image:hover {
          color: #F73131;
        }

        p {
          font-size: 14px;
        }
      }

      .explain-text {
        font-size: 14px;
        line-height: 35px;
        color: #585858;
        padding-left: 30px;

        ol > li {
          list-style-type:decimal;
        }
      }
      
      .label {
        margin-top: 120px;
        width: 100%;
        display: flex;
        justify-content: space-around;
        padding-bottom: 100px;
        &-item {
          img {
            height: 65px;
            width: auto;
            margin: 0 auto;
            display: block;
          }
          div {
            text-align: center;
            font-size: 14px;
            color: #585858;
            margin-top: 20px;
          }
        }
      }
      .title {
        font-size: 20px;
        color: #585858;
        text-align: center;
        margin-top: 60px;
      }

      /deep/ .card {
        width: 315px;
        height: 210px;
        float: left;
      }

      .right {
        position: relative;
        width: 270px;
        height: 187px;
        float: right;

        h3 {
          color: #333;
          font-weight: 800;
          font-size: 16px;
          line-height: 40px;
        }

        .list {
          margin-top: 20px;
          .item {
            padding: 6px 17px;
            border: 1px solid #ef4c57;
            border-radius: 3px;
            background-color: #ffd6d6;
            color: #f30000;
            margin-right: 5px;
            float: left;
            margin-bottom: 5px;
            font-size: 10px !important;
          }

          .blue {
            border-color: #45bbf1;
            background-color: #c3edff;
            color: #0066a1;
          }
          .violet {
            border-color: #916eab;
            background-color: #f2e1ff;
            color: #5c307d;
          }
        }

        .price {
          position: absolute;
          width: 100%;
          left: 0;
          bottom: 10px;
          font-size: 23px;
          font-weight: 900;
          color: #f30000;
          cursor: pointer;

          button {
            background: #d60000;
            float: right;
            width: 116px;
            height: 32px;
            border-radius: 32px;
            color: #fff;
            font-size: 16px;
            line-height: 32px;
            text-align: center;
            border: none;
            outline: none;
            margin-right: 10px;
            cursor: pointer;
          }
        }
      }
    }

    .vip_no {
      height: 500px;
      background: #fff;
      p {
        width: 100%;
        padding-top: 150px;
        color: #585858;
        font-size: 20px;
        text-align: center;
      }
    }

    /deep/ .pay-dialod-visible {
      width: 612px;
      height: auto;
      padding-bottom: 20px;
      background-color: #fff;
      .count {
        .wx_box_success {
          h3 {
            font-size: 30px;
            color: #585858;
            text-align: center;
          }
        }
        .wx_box {
          background-color: #fff;
          margin-top: 15px;
          &-price {
            text-align: center;
          }
          h3 {
            font-size: 18px;
            color: #585858;
            text-align: center;
          }

          .price {
            text-align: center;
            font-size: 18px;
            color: #585858;
            margin-top: 20px;

            .p_num {
              font-size: 28px;
              text-decoration: line-through;
            }

            .p_num_new {
              font-size: 28px;
              color: #e50001;
            }

            
          }

        }
        .zfb_box {
          background-color: #fff;
          h3 {
            font-size: 18px;
            color: #585858;
            text-align: center;
          }
          ul {
            li {
              font-size: 16px;
              padding-left: 20px;

              .label {
                color: #a8a8a8;
                display: inline-block;
                width: 100px;
              }

              .fillIn {
                float: right;
                margin-right: 20px;
                margin-top: -8px;
              }

              margin-bottom: 20px;
            }
          }
          .tip {
            font-size: 15px;
            color: #a8a8a8;
            margin-left: 20px;
            margin-top: 50px;
          }
          .illustration {
            width: 100%;
            float: left;
            font-size: 12px;
            color: #a8a8a8;
            text-align: center;
          }
        .foot-vip{
          .text-info{
            font-size : 16px;text-align:center;
          }
          .btn-container{
            display: flex;
            align-items: center;
            /deep/ .el-button{
              background : #1890FF;
              margin-left:245px;
              color:#FFF;
              margin-top:20px;
            }
          }
        }
        }
        width: 100%;
        height: 100%;
        position: relative;
        .has_active_price {
          font-size: 28px;
          color: red;
          line-height: 58px;
          margin-left: 38px;
          width: 180px;

          .lineation {
            font-size: 16px;
            color: #a6a6a6;
            text-decoration: line-through;
          }
        }
        .vip_card {
          width: 290px;
          float: right;
          height: auto;
          margin-right: 10px;
          margin-top: 10px;
          cursor: pointer;
        }
        .right_c {
          width: 100%;
          height: 300px;
          float: right;
          background-color: #fff;
          display: flex;
          justify-content: space-around;
          align-items: center;

          .wx {
            width: 190px;
            float: left;
            height:60px;
            position: relative;
            img {
              width: 100%;
              height: 100%;
            }
            cursor: pointer;
          }

          .wx:hover{
            box-shadow: 10px 10px 10px #ddd;
          }

          .zfb {
            width: 190px;
            height:60px;
            float: right;
            cursor: pointer;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .zfb:hover {
            box-shadow: 10px 10px 10px #ddd;
          }
        }
        .right {
          .right_QrCode {
            width: 200px;
            margin: 10px auto;
            .right_QrCode_img {
              width: 200px !important;
              height: 200px !important;
            }
            img {
              width: 200px !important;
              height: 200px !important;
            }
          }
          .imageOne {
            width: 100%;
          }
        }

        .pOne {
          width: 100%;
          color: #575757;
          margin-top: 10px;
          font-size: 16px;
          text-align: center;

          .pay_r {
            float: right;
            cursor: pointer;
          }
        }
      }
    }

    .pay_types {
      margin-top: 53px;
      margin-left: 38px;
      font-size: 20px;
      color: #585858;
      text-align: left;
    }

    .right_f {
      width: 100%;
      // float: right;
      background-color: #fff;
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex-wrap: wrap;

      .wx {
        margin-top: 26px;
        width: 225px;
        float: left;
        height: 120px;
        position: relative;
        border-radius: 6px;
        background-color: #fff;
        border: 1px solid #a6a6a6;
        .pay_logo {
          width: 50px;
          height: auto;
          float: left;
          margin-top: 35px;
          margin-left: 20px;
        }
        .pay_type {
          display: inline-block;
          font-size: 14px;
          color: #585858;
          float: left;
          margin-left: 20px;
          margin-top: 35px;
        }
        .pay_num {
          display: inline-block;
          font-size: 20px;
          color: #585858;
          float: left;
          margin-left: 20px;
          min-width: 100px;
        }
        cursor: pointer;
      }

      .wx:hover{
        box-shadow: 10px 10px 10px #ddd;
      }

      .zfb {
        margin-top: 26px;
        border-radius: 6px;
        width: 225px;
        height: 120px;
        float: right;
        cursor: pointer;
        border: 1px solid #a6a6a6;
        background-color: #fff;
        .pay_logo {
          width: 50px;
          height: auto;
          float: left;
          margin-top: 35px;
          margin-left: 20px;
        }
        .pay_type {
          display: inline-block;
          font-size: 14px;
          color: #585858;
          float: left;
          margin-left: 20px;
          margin-top: 35px;
        }
        .pay_num {
          display: inline-block;
          font-size: 20px;
          color: #585858;
          float: left;
          margin-left: 20px;
          min-width: 100px;
        }
      }
      .zfb:hover {
        box-shadow: 10px 10px 10px #ddd;
      }

      .balance {
        margin-top: 26px;
        border-radius: 6px;
        width: 510px;
        height: 60px;
        cursor: pointer;
        border: 1px solid #a6a6a6;
        background-color: #fff;
        .left {
          float: left;
          width: 330px;
          margin-left: 18px;
          img {
            width: 47px;
            float: left;
            margin-top: 9px;
            margin-right: 10px;
          }
          .msg {
            float: left;
            line-height: 60px;
            font-size: 18px;
          }
        }
        .right {
          float: right;
          width: 88px;
          height: 58px;
          color: #fff;
          background: #5c307d;
          border-radius: 4px;
          border: none;
          outline: none;
          font-size: 18px;
          cursor: pointer;
        }
      }
      .balance:hover {
        box-shadow: 10px 10px 10px #ddd;
      }
    }
  }
</style>

<style lang="scss" scoped>
.yuanjia {
  font-size: 16px;
  color: #585858;
  line-height: 30px;
  margin-top: 10px;
}
.xianjia {
  font-size: 16px;
  color: #585858;
  line-height: 30px;
}
</style>
